import soundManager from '../managers/SoundManager';
import game from '../game';
import { gameArea } from '../utils/gameArea';
import CRTShader from '../shaders/CRT';

export default class Boot extends Phaser.Scene {
    CRTPipeline: any;
    WobblePipeline: any;

    constructor() {
        super({ key: 'Boot', active: true });
    }
  
    preload() {

        var width = this.cameras.main.width;
        var height = this.cameras.main.height;

        var loadingText = this.make.text({
            x: width / 2,
            y: height / 2 - 50,
            text: 'Loading...',
            style: {
                font: '20px monospace',
                fill: '#ffffff'
            }
        });
        var percentText = this.make.text({
            x: width / 2,
            y: height / 2 - 5,
            text: '0%',
            style: {
                font: '18px monospace',
                fill: '#ffffff'
            }
        });
        var assetText = this.make.text({
            x: width / 2,
            y: height / 2 + 50,
            text: '',
            style: {
                font: '18px monospace',
                fill: '#ffffff'
            }
        });

        assetText.setOrigin(0.5, 0.5);
        percentText.setOrigin(0.5, 0.5);
        loadingText.setOrigin(0.5, 0.5);

        this.load.on('progress', function (value) {
            percentText.setText( (parseInt(value) * 100) + '%');
        });
        this.load.on('fileprogress', function (file) {
            assetText.setText('Loading asset: ' + file.key);
        });

        this.load.on('complete', () => {
            loadingText.destroy();
            percentText.destroy();
            assetText.destroy();
            //preload scenes
            ['TextBlurbScene','PauseEndScene','GameScene','HUDScene','MainMenuScene'].forEach( sceneName => {
                this.scene.start(sceneName);
                const muhScene = this.scene.get(sceneName);
                muhScene.scene.sleep();
            })
            this.scene.start('Splash');
        });


        //load assets here!
        this.load.image('backgroundTile', './assets/images/background.png');
        this.load.image('IdentLogo', './assets/images/IdentLogo.png');
        this.load.image('arenaTiles', './assets/tiles/ArenaFuturaMaptiles-extruded.png');
        this.load.image('playerShadow','./assets/sprites/8bitManShadow.png');
        this.load.spritesheet('pinkManSpriteSheet','./assets/sprites/8bitPinkMan.png',{ margin: 1, spacing:2, frameWidth: 32, frameHeight: 32 });
        this.load.spritesheet('blueManSpriteSheet','./assets/sprites/8bitBlueMan.png',{ margin: 1, spacing:2, frameWidth: 32, frameHeight: 32 });
        this.load.spritesheet('cyberManSpriteSheet','./assets/sprites/8bitCyberMan.png',{ margin: 1, spacing:2, frameWidth: 32, frameHeight: 32 });
        this.load.spritesheet('chargePickupSpriteSheet','./assets/sprites/chargePickup.png', { margin: 1, spacing: 2, frameWidth: 8, frameHeight: 8 });
        this.load.spritesheet('energyBallSpriteSheet','./assets/sprites/energyBall.png', { margin: 1, spacing: 2, frameWidth: 32, frameHeight: 32 });
        this.load.spritesheet('energyBallMachineSpriteSheet','./assets/sprites/energyBallMachine.png', { margin: 1, spacing: 2, frameWidth: 16, frameHeight: 16 });

        //@ts-ignore
        this.load.webfont('Practice', './assets/fonts/Practice-font.otf');

        //audio
        this.load.audio("menuTheme",["./assets/audio/music/FM-Menu-Theme.ogg","./assets/audio/music/FM-Menu-Theme.mp3"]);
        this.load.audio("battleTheme",["./assets/audio/music/FM-Battle-Theme.ogg","./assets/audio/music/FM-Battle-Theme.mp3"]);

        this.load.audio("countInNormal",["./assets/audio/FX/countInNormal.ogg","./assets/audio/FX/countInNormal.ogg"]);
        this.load.audio("pickup",["./assets/audio/FX/pickup.ogg","./assets/audio/FX/pickup.mp3"]);
        this.load.audio("swing",["./assets/audio/FX/swing.ogg","./assets/audio/FX/swing.mp3"]);
        this.load.audio("hit1",["./assets/audio/FX/hit-1.ogg","./assets/audio/FX/hit-1.mp3"]);
        this.load.audio("hit2",["./assets/audio/FX/hit-2.ogg","./assets/audio/FX/hit-2.mp3"]);
        this.load.audio('menuChange',['./assets/audio/FX/menuChange.ogg','./assets/audio/FX/menuChange.mp3']);
        this.load.audio('menuSelect',['./assets/audio/FX/menuSelect.ogg','./assets/audio/FX/menuSelect.mp3']);
        this.load.audio('bossDeath',['./assets/audio/FX/bossDeath.ogg','./assets/audio/FX/bossDeath.mp3']);
        this.load.audio('machineHit',['./assets/audio/FX/machineHit.ogg','./assets/audio/FX/machineHit.mp3']);
        this.load.audio('death',['./assets/audio/FX/death.ogg','./assets/audio/FX/death.mp3']);
        this.load.audio('energyFiring',['./assets/audio/FX/energyFiring.ogg','./assets/audio/FX/energyFiring.mp3']);
    }

    create(){
        this.sys.canvas.style.cursor = "none";

        soundManager.setScene(this);
        soundManager.addMusic("battleTheme");
        soundManager.addMusic("menuTheme");
        soundManager.addSfx("pickup");
        soundManager.addSfx("swing");
        soundManager.addSfx("countInNormal");
        soundManager.addSfx("hit1");
        soundManager.addSfx("hit2");
        soundManager.addSfx('menuChange');
        soundManager.addSfx('menuSelect');
        soundManager.addSfx('death');
        soundManager.addSfx('bossDeath');
        soundManager.addSfx('machineHit');
        soundManager.addSfx('energyFiring');
        const renderer = <Phaser.Renderer.WebGL.WebGLRenderer>game.renderer;
        this.CRTPipeline = renderer.addPipeline('CRT', new CRTShader(game));
        this.CRTPipeline.setFloat2('resolution', gameArea.screenWidth, gameArea.screenHeight);
        this.CRTPipeline.time = 0;
        this.CRTPipeline.intensity = 0.1;

    }
  
  }